export const INPUT_CLASSNAMES = {
  solid: 'bg-base-200/50',
  outline: 'input-bordered',
  ghost: 'input-ghost',
}
